export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11181.166a9b8f.jpg";